<template>
    <ViewEmailSetting :configKey="configKey" />
</template>


<script>
import ViewEmailSetting from '@/views/admin/settings/email/ViewEmailSetting.vue';

export default {
    name: 'LeadEmailSettings',
    props: {},
    components: {
        ViewEmailSetting
    },

    data() {
        return {}
    },

    methods: {},

    computed: {
        configKey: () => 'NewLeadEmail',
    },

    watch: {},
};
</script>


<style lang='scss' scoped></style>